import { render, staticRenderFns } from "./OrderNotDelivered.vue?vue&type=template&id=614a4967&scoped=true&"
import script from "./OrderNotDelivered.vue?vue&type=script&lang=js&"
export * from "./OrderNotDelivered.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotDelivered.vue?vue&type=style&index=0&id=614a4967&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a4967",
  null
  
)

export default component.exports